import * as FilerrsActionTypes from '../../types/filerrs';
import * as FilerrsSelectors from '../../selectors/filerrs';

export const setFilerrs = (payload) => (dispatch, getState) =>
    FilerrsSelectors.isEmpty(getState()) &&
    dispatch({
        type: FilerrsActionTypes.SET_FILERRS,
        payload
    });
